import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output} from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'submit',
  template: `<div>
  <p class="validation__error error_message" *ngIf="serverError">
    {{ serverError }}
  </p>
  <button type="submit"
          class="validation__button button noselect"
          [class.disabled]="isDisabled"
          [style.background-color]="background">
    <ng-content></ng-content>
  </button>
</div>

`,
  styles: [`.validation__error{text-align:right}.validation__button{float:right;color:#fff}.validation__button.disabled{pointer-events:none;opacity:.5}`],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubmitComponent implements OnChanges {

  @Input('form') form: FormControl;
  @Input('background') background: string;
  @Input('serverError') serverError: string;

  @Output('vClick') vClick: EventEmitter<any> = new EventEmitter<any>();

  public isDisabled: boolean;

  constructor() {}

  public ngOnChanges() {
    this.checkValidation();
  }

  private checkValidation() {
    this.isDisabled = this.form ? ( !this.form.valid || this.form.pristine ) : true;
  }

  @HostListener('click')
  click() {
    if( !this.isDisabled ) {
      this.vClick.emit();
    }
  }
}
